import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("orderId");

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
   const navi= useNavigate()
    useEffect(() => {
        if (orderId) {
            checkPaymentStatus(orderId);
        }
    }, [orderId]);

    const checkPaymentStatus = async (orderId) => {
        try {
            // 1️⃣ Get PhonePe auth token
            const tokenRes = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
            const token = tokenRes.data.access_token;

            // 2️⃣ Verify payment
            const res = await axios.post(`https://ramjitrust.org:4000/payment/verify-payment`, { orderId, token });
            const state = res.data?.state;
            console.log("Payment status:", state);

            if (state === "COMPLETED") {
                setMessage("✅ Payment Successful");
                alert("✅ Payment Successful");

                // 3️⃣ Submit temporary form for registration
                try {
                    const finalRes = await axios.post(`https://ramjitrust.org:4000/form/submit-temp`, { orderId });
                    if (finalRes.status === 200) {
                        alert("🎉 Registration completed successfully!");
                        setMessage("🎉 Registration completed successfully!");
                    } else {
                        alert("⚠ Registration finalization failed.");
                        setMessage("⚠ Registration finalization failed.");
                    }
                } catch (error) {
                    console.error("❌ Error during registration finalization:", error.response?.data || error.message);
                    // alert("❌ Error during registration finalization.");
                    setMessage("❌ Error during registration finalization.");
                }

                // 4️⃣ Move to successful_wallet and update wallet balance
                try {
                    const walletRes = await axios.post(`https://ramjitrust.org:4000/form/move-to-successful`, { orderId });
                    if (walletRes.status === 200) {
                        
                    } else {
                        console.log("⚠ Failed to move wallet entries.");
                        setMessage(prev => prev + " ⚠ Failed to update wallet.");
                    }
                } catch (error) {
                    console.error("❌ Error updating wallet:", error.response?.data || error.message);
                    setMessage(prev => prev + " ❌ Error updating wallet.");
                }
                 
        
                  try {
                            // alert(orderId)
          const response = await axios.post(`https://ramjitrust.org:4000/meeting/submit_meeting_form`, { orderId });
          alert('move meeting entries')
                   localStorage.setItem("meetingData", JSON.stringify(response.data));
                    localStorage.setItem("meetingDatas", JSON.stringify(response.data.data.full_name));

           navi('/meetingticket', {
    state: {
      meetingData: response.data.data
    }
  });
        //   if (meetingform.status !== 200) {
        //     console.log("⚠ Failed to move meeting entries.");
        //     setMessage(prev => prev + " ⚠ Failed to update meeting.");
        //   }
        } catch (error) {
          console.error("❌ Meeting update error:", error.response?.data || error.message);
          setMessage(prev => prev + " ❌ Error updating meeting.");
        }

         
            } else if (state === "FAILED") {
                alert("❌ Payment Failed");
                setMessage("❌ Payment Failed");
            } else if (state === "PENDING") {
                     
       
         

                alert("⏳ Payment is still pending");
                setMessage("⏳ Payment is still pending");
            } else {
                alert(`ℹ Payment status: ${state}`);
                setMessage(`ℹ Payment status: ${state}`);
            }

        } catch (error) {
            console.error("❌ Error fetching payment status:", error.response?.data || error.message);
            alert("❌ Could not verify payment.");
            setMessage("❌ Could not verify payment.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 20 }}>
            <h2>Please note your student ID for your examination</h2>
            {loading ? (
                <h3>🔄 Checking payment status, please wait...</h3>
            ) : (
                <h3>{message}</h3>
            )}
        </div>
    );
};

export default PaymentSuccess;
